import { trackEvent } from 'core-lib/utils/events';
import { getCommonEventAttr } from './index';

export const trackModelPageLoaded = () => {
  trackEvent({
    name: 'car_listing_model_page_loaded',
    defaultAttr: getCommonEventAttr(),
  });
};

export const trackShareClicked = () => {
  trackEvent({
    name: 'car_listing_model_share',
    defaultAttr: getCommonEventAttr(),
  });
};
